import React, { Component } from "react";
import Icons from "../../icon";
export class TabberButton extends Component {
    constructor(props) {
        super(props);
        this.state={
            active: false
        }
        this.onClickTabber=this.onClickTabber.bind(this);
    }
    onClickTabber() {
        const { onToggle, disabled } = this.props;

        if (disabled) {
            return;
        }

        var isActive = !this.state.active;
        this.setState({ active: isActive });

        if (onToggle) {
            onToggle(isActive);
        }
    }

    tabActive = () => {
        return this.state.active;
    }

    toggle(isActive) {
        const { onToggle, disabled } = this.props;

        if (disabled) {
            return;
        }

        this.setState({ active: isActive });

        if (onToggle) {
            onToggle(isActive);
        }
    }

    componentDidMount(){
        this.setState({ active: this.props.value });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ active: this.props.value });
        }
    }

    render(){
        const { title, disabled } = this.props;
        return (
            <div className={`tabber-layout-container`}>
                <h1 className="title">{title && title}</h1>
                <div className="tabber-container">
                    <div className={`tabber-inner-container ${disabled && 'disabled'} ${this.state.active ? 'tabber-active' : null}`} onClick={!disabled ? this.onClickTabber : null}>
                        <div className="tabber-container-circle">
                        {this.state.active &&
                            <Icons
                                customClassName="icon-check-reg"
                                name="check"
                                size="16px"
                                containerClass="icon-circle-plus-container"
                            /> 
                        }
                        </div>										
                    </div>
                    <span className={`${this.state.active ? 'tabber-label-active' : 'tabber-label-off'}`}>{this.props.label}</span>
                </div>
            </div>
        );
    }
}